import React from 'react';
import { View, Text, Image } from 'react-native';
import {
  CommonPortraitCreditCardStyles,
  CommonLandscapeCreditCardStyles,
  PortraitStyles,
  LandscapeStyles,
} from '../styles/CommonCreditCardStyles';

const VISA = 'VI';

const FrontCreditCard = (props) => {
  const { creditCardNumber, CreditCardVendorCode, isPortrait } = props;
  const firstFourNumbers = creditCardNumber.substr(0, 4);
  const secondFourNumbers = creditCardNumber.substr(4, 4);
  const thirdFourNumbers = creditCardNumber.substr(8, 4);
  const fourthFourNumbers = creditCardNumber.substr(12, 4);
  const styles = isPortrait ? PortraitStyles : LandscapeStyles;
  return (
    <View
      style={
        isPortrait
          ? CommonPortraitCreditCardStyles.container
          : CommonLandscapeCreditCardStyles.container
      }
    >
      {/* Left part of the card */}
      <View style={styles.leftSideContainer}>
        <View style={styles.titleContainer}>
          <Text style={styles.leftTitleText}>easy</Text>
        </View>
        <View style={styles.leftChipIconContainer}>
          <Image source={require('../assets/images/easy-chip.png')} style={styles.chipIconStyle} />
        </View>
        <View style={styles.cardNumberContainer}>
          <Text style={styles.leftCardNumberText}>
            {firstFourNumbers} {secondFourNumbers}{' '}
          </Text>
        </View>
        <View style={styles.leftFooterContainer}></View>
      </View>

      {/* Vertical dividing line */}
      <View style={styles.divider} />

      {/* Right part of the card */}
      <View style={styles.rightSideContainer}>
        <View style={styles.titleContainer}>
          <Text style={styles.rightTitleText}>card</Text>
        </View>
        <View style={styles.rightChipIconContainer}></View>
        <View style={styles.cardNumberContainer}>
          <Text style={styles.rightCardNumberText}>
            {' '}
            {thirdFourNumbers} {fourthFourNumbers}
          </Text>
        </View>
        <View style={styles.rightFooterContainer}>
          {CreditCardVendorCode === VISA && (
            <Image
              source={require('../assets/images/visa-logo.png')}
              style={styles.visaIconStyle}
            />
          )}
        </View>
      </View>
    </View>
  );
};

export default FrontCreditCard;
